import * as PopupEditor from '@bingads-webui/popup-editor';
import { InlineSuggestedParamValueSave } from './save';

export function InlineSuggestedParamValueColumnPrompt({
  position, item, field, view, i18n, newI18n, key,
}) {
  const schema = {
    key: 'Id',
    name: 'Keyword',
    parent: 'AdGroup',
    properties: {
      Param1: {
        $ref: 'Edm/String', type: 'string', name: 'String', bulkDeleteValueIfEmpty: true,
      },
      Param2: {
        $ref: 'Edm/String', type: 'string', name: 'String', bulkDeleteValueIfEmpty: true,
      },
      Param3: {
        $ref: 'Edm/String', type: 'string', name: 'String', bulkDeleteValueIfEmpty: true,
      },
    },
    type: 'object',
  };

  const fields = [field];

  PopupEditor.prompt({
    position,
    i18n,
    schema,
    model: item,
    fields,
    hasLabels: false,
    template: 'inline',
    parentContainerSelector: '.grid-and-disclaim-container',
    saveModel: (updated, editorView) =>
      InlineSuggestedParamValueSave({
        view,
        updated,
        key,
        editorView,
        field,
        newI18n,
      }),
  });
}
